import { useSelector } from "react-redux";

export function useNotifications() {
  return useSelector((state) => state.notifications);
}
